// @flow
import React from 'react'
import styled from 'styled-components'
import Dropdown from 'components/Dropdown'
import * as cf from 'cf'

import alertStore from 'stores/alert'

import componentStore from 'stores/components'

type State = {
    locale: string,
    gridArea: string
}

export default class CopySingleComponents extends React.Component<{},State> {

    state = {
        locale: '',
        gridArea: '',
    }

    handleLocaleChange = (locale:*) => this.setState({locale})
    handleGridAreaChange = (gridArea:*) => this.setState({gridArea})
    handleButtonClick = () => {
        if(!this.state.locale || !this.state.gridArea) return
        alertStore.set({
            title: `Klonen Komponente "${this.state.gridArea}" von ${this.state.locale}`,
            body: ``,
            onOk: () => {
                const result = cf.getComponentFromLocale(this.state.locale, this.state.gridArea)
                if(!result) return
                componentStore.setComponent(result)
            }
        })
    }

    render(){
        return (
            <Wrapper>
                <Dropdown 
                    placeholder='locale'
                    values={cf.getLocales()}
                    value={this.state.locale}
                    onChange={this.handleLocaleChange}
                />
                <Dropdown 
                    placeholder='grid-area'
                    values={this.state.locale ? cf.getGridAreasByLocale(this.state.locale) : []}
                    value={this.state.gridArea}
                    onChange={this.handleGridAreaChange}
                />
                <Button className="Button" onClick={this.handleButtonClick}>Copy</Button>
            </Wrapper>
        )
    }
}

const Wrapper = styled.div`
    display: flex;
    > .Dropdown { flex: 1; margin-right: 5px; }
    > .Button { flex: 1; }
`

const Button = styled.div`
    background: rgb(0, 150, 136);
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`


// WEBPACK FOOTER //
// ./src/config/CopySingleComponent.js